import React from 'react';
import { connect } from "react-redux";
import {setWallsLockMode} from "../../../../../actions/sqftMenuFunctions";

const WallsLockModeButton = (props) => {
  const {isWallsLockMode, setWallsLockMode} = props;

  const handleButtonClick = () => {
    setWallsLockMode(!isWallsLockMode);
  };

  return (
    <div className="ui-button-block">
      <button className={"button--rounded button--icon-lock-40-white walls-lock-mode " + (isWallsLockMode ? "button-active" : "walls-lock-mode--unlocked")}
              type="button"
              aria-label="Snap drawing to 45°"
              aria-pressed={isWallsLockMode}
              title={isWallsLockMode ? "45° snapping: on" : "45° snapping: off"}
              onClick={handleButtonClick}>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => ({
  isWallsLockMode: store.sqftMenuState.isWallsLockMode,
});

const mapDispatchToProps = {
  setWallsLockMode
};


export default connect(mapStateToProps, mapDispatchToProps)(WallsLockModeButton);
